module.exports = __webpack_public_path__ + "images/VK.ee58b0036922d49ab9cee5dd8c27f55c.png";